import React from "react";

const CustomPDFViewer = ({ fileUrl }: { fileUrl: string }) => {
   return (
      <iframe title="PDF Viewer" src={fileUrl} style={{ width: '100%', height: '100%', border: 'none' }} />
   );
};

export default CustomPDFViewer;
